/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
import Results from "./Results.js";
// import Comparison from "./Comparison.js";
import training_video from "./images/method-01.png"
import overview from "./images/method-02.png";
import main_figure from "./video/icml-rebuttal/q3/main_figure.png"
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";

import LazyVideo from "./lazy-video";
import training1 from "./video/training/training-1.mp4"
import training2 from "./video/training/training-2.mp4"
import training3 from "./video/training/training-3.mp4"

import rese1 from "./video/simple/simple-1.mp4"
import rese2 from "./video/simple/simple-2.mp4"
import rese3 from "./video/simple/simple-3.mp4"

import compare1 from "./video/comparison/0-seek-0-ac3d.mp4"
import compare2 from "./video/Comparison/0-seek-0-cameractrl.mp4"
import compare3 from "./video/comparison/0-seek-0-oursac.mp4"
import compare4 from "./video/comparison/4-fwd-0-ac3d.mp4"
import compare5 from "./video/Comparison/4-fwd-0-cameractrl.mp4"
import compare6 from "./video/comparison/4-fwd-0-oursac.mp4"

import simple_pose from './video/comparison/simple_pose.png';
import seek_pose from './video/comparison/seek_pose.png';
import switch_pose from './video/comparison/switch_pose.png';
import exp_pose from './video/comparison/explosion_pose.png';
import rot_pose from './video/comparison/rotate_pose.png';


import excompare1d1 from "./video/comparison/0-seek-0-cameractrl.mp4"
import excompare1d2 from "./video/comparison/0-seek-0-cog.mp4"
import excompare1d3 from "./video/comparison/0-seek-0-ac3d.mp4"
import excompare1d4 from "./video/comparison/0-seek-0-ourscog.mp4"
import excompare1d5 from "./video/comparison/0-seek-0-oursac.mp4"

import excompare2d1 from "./video/comparison/1-explosion-0-cameractrl.mp4"
import excompare2d2 from "./video/comparison/1-explosion-0-cog.mp4"
import excompare2d3 from "./video/comparison/1-explosion-0-ac3d.mp4"
import excompare2d4 from "./video/comparison/1-explosion-0-ourscog.mp4"
import excompare2d5 from "./video/comparison/1-explosion-0-oursac.mp4"

import excompare3d1 from "./video/comparison/2-switch-0-cameractrl.mp4"
import excompare3d2 from "./video/comparison/2-switch-0-cog.mp4"
import excompare3d3 from "./video/comparison/2-switch-0-ac3d.mp4"
import excompare3d4 from "./video/comparison/2-switch-0-ourscog.mp4"
import excompare3d5 from "./video/comparison/2-switch-0-oursac.mp4"

import excompare4d1 from "./video/comparison/3-rotate-0-cameractrl.mp4"
import excompare4d2 from "./video/comparison/3-rotate-0-cog.mp4"
import excompare4d3 from "./video/comparison/3-rotate-0-ac3d.mp4"
import excompare4d4 from "./video/comparison/3-rotate-0-ourscog.mp4"
import excompare4d5 from "./video/comparison/3-rotate-0-oursac.mp4"


import teaser1 from "./video/track-teaser.mp4"
import teaser2 from "./video/fwd_right-teaser.mp4"
import teaser3 from "./video/seek-teaser.mp4"

import res1 from "./video/composed/bwd-left01.mp4"
import res2 from "./video/composed/fwd-right02.mp4"

import res3 from "./video/complex/seek2.mp4"
import res4 from "./video/complex/seek3.mp4"
import res5 from "./video/complex/explosion.mp4"
import res6 from "./video/complex/explosion2.mp4"
import res7 from "./video/complex/rotate02.mp4"
import res8 from "./video/complex/switch-track2.mp4"
import res9 from "./video/complex/seek4.mp4"
import res10 from "./video/complex/rotate01.mp4"
import res11 from "./video/complex/shake01.mp4"
import res12 from "./video/complex/switch-track1.mp4"


import resc1 from "./video/composed/fwd-left01.mp4"
import resc2 from "./video/composed/bwd-left02.mp4"
import resc3 from "./video/composed/bwd-right01.mp4"
import resc4 from "./video/composed/fwd-right01.mp4"

import new1 from "./video/new/1_dolly_zoom.mp4"
import new2 from "./video/new/2_dolly_zoom.mp4"
import new3 from "./video/new/1_pan_right.mp4"
import new4 from "./video/new/2_pan_right.mp4"
import new5 from "./video/new/0_roll.mp4"
import new6 from "./video/new/3_dynamiccut.mp4"

import rebuttal1 from "./video/rebuttal/rotate-cartoon.mp4"
import rebuttal2 from "./video/rebuttal/seek-cartoon.mp4"
import rebuttal3 from "./video/rebuttal/switch-cartoon.mp4"
import rebuttal4 from "./video/rebuttal/explosive-wan.mp4"
import rebuttal5 from "./video/rebuttal/seek-wan.mp4"
import rebuttal6 from "./video/rebuttal/switch-wan.mp4"

import rebuttalq1baseline from "./video/icml-rebuttal/q1/baseline.mp4"
import rebuttalq1ours from "./video/icml-rebuttal/q1/ours.mp4"
import rebuttalq2bird from "./video/icml-rebuttal/q2/0-0-search-bird.mp4"
import rebuttalq4traj from "./video/icml-rebuttal/q4/trajectory.png"
import rebuttalq4vid from "./video/icml-rebuttal/q4/video.mp4"
import rebuttalq5bad0 from "./video/icml-rebuttal/q5/0_bad.mp4"
import rebuttalq5bad1 from "./video/icml-rebuttal/q5/1_bad.mp4"
import rebuttalq5good0 from "./video/icml-rebuttal/q5/0_good.mp4"
import rebuttalq5good1 from "./video/icml-rebuttal/q5/1_good.mp4"
import rebuttalq6_1_1 from "./video/icml-rebuttal/q6/1-plain.mp4"
import rebuttalq6_1_2 from "./video/icml-rebuttal/q6/1-vivid.mp4"
import rebuttalq6_3 from "./video/icml-rebuttal/q6/3-toolong.mp4"
import rebuttalq7dual_switch from "./video/icml-rebuttal/q7/rebuttalq7dual_switch.mp4"
import rebuttalq7dual_seek from "./video/icml-rebuttal/q7/rebuttalq7dual_seek.mp4"
import rebuttalq7ours_seek from "./video/icml-rebuttal/q7/rebuttalq7ours_seek.mp4"
import rebuttalq7ours_switch from "./video/icml-rebuttal/q7/rebuttalq7ours_switch.mp4"
import gray_depth_1 from "./video/icml-rebuttal/q7/gray_depth_1.png"
import gray_depth_2 from "./video/icml-rebuttal/q7/gray_depth_2.png"


const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeR"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
        <span style={{ color: "#ff5722", fontFamily: "Momentz, sans-serif" }}>Vivid</span><span style={{ color: "#03a9f4", fontFamily: "Momentz, sans-serif" }}>Cam</span>: 
        Generating Unconventional <span style={{ color: "#03a9f4" }}>Cam</span>era Motions from <br></br>
        <span style={{ color: "#ff5722"}}>Vi</span>rtual Synthetic <span style={{ color: "#ff5722"}}>Vid</span>eos
      </div>
    </Header>
  </Container>
);

// HomepageHeading.propTypes = {
//   mobile: PropTypes.bool,
// };

// const history = useHistory();

// const handleClick = () => history.push('/post');

// if(handleClick) {
//   db.collection("posts").doc(postId).update({
//     views: increment,
//   })
// }

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Container fluid  style={{ paddingLeft: "8vw", paddingRight: "8vw" }}>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={1}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
            marginTop: "0.5em",
            marginBottom: "0.5em",
          }}
        >
        </Grid>
      </Container>
      <Container fluid style={{ paddingLeft: "8vw", paddingRight: "8vw" }}>
        <Abstract mobile={mobile} />
        <Header as="h2" textAlign="center" style={subsection_style}>
          Challenges in Video Generation with Unconventional Camera Motions
        </Header>
        <p>
        While recent camera control methods for video generative models can effectively synthesize <b>simple</b> camera motions, they face significant challenges when handling more <b>complex</b> or <b>unconventional</b> motion patterns. We show examples below.
        </p>
<Grid columns={4} stackable>
  <Grid.Row>
    <Grid.Column textAlign="center">
      <img src={simple_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>

    <Grid.Column textAlign="center">
      <LazyVideo src={compare4} />
  <p>
  <strong>AC3D</strong> <strong style={{ color: "green" }}>SUCCESS</strong>
  </p>
    </Grid.Column>

    <Grid.Column textAlign="center">
      <LazyVideo src={compare5} />
  <p>
  <strong>CameraCtrl</strong> <strong style={{ color: "green" }}>SUCCESS</strong>
  </p>
    </Grid.Column>
        <Grid.Column textAlign="center">
      <LazyVideo src={compare6} />
  <p>
  <strong>VividCam (Ours)</strong> <strong style={{ color: "green" }}>SUCCESS</strong>
  </p>
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
  <strong style={{ color: "blue" }}>Camera (Simple):</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward, focusing</strong> on a bowl of fresh strawberries.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> The bowl sits on a picnic blanket in a meadow, with a wicker basket and wildflowers nearby.
</p>


  <Grid columns={4} stackable>
  <Grid.Row>
    <Grid.Column textAlign="center">
      <img src={seek_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>

    <Grid.Column textAlign="center">
      <LazyVideo src={compare1} />
  <p>
  <strong>AC3D</strong> <strong style={{ color: "red" }}>FAIL</strong>
  </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={compare2} />
  <p>
  <strong>CameraCtrl</strong> <strong style={{ color: "red" }}>FAIL</strong>
  </p>
    </Grid.Column>
        <Grid.Column textAlign="center">
      <LazyVideo src={compare3} />
  <p>
  <strong>VividCam (Ours)</strong> <strong style={{ color: "green" }}>SUCCESS</strong>
  </p>
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
  <strong style={{ color: "blue" }}>Camera (Unconventional):</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> a sunflower in a glass vase. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus</strong> and
  <strong style={{ color: "blue" }}> pushes in</strong> on the vibrant yellow petals.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A sunflower sits in a glass vase on a windowsill, with sunlight streaming in and casting soft shadows on the sill.
</p>

        <Header as="h2" textAlign="center" style={subsection_style}>
          Our Synthesized Training Videos
        </Header>
        <p>
        Our training videos consist of very basic geometries in low-poly 3D scenes. They can be rendered easily in Unity.
        </p>
  <div>
    <Grid columns={3}>
    <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={training1} />
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={training2} />
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={training3} />
    </Grid.Column>
    </Grid.Row>
    </Grid>
  </div>

        <Results />

<Header as="h2" textAlign="center" style={subsection_style}>
          Qualitative Comparisons
        </Header>
        <p>
        We present additional comparisons between our method and baseline approaches. The unconventional camera motions are particularly challenging for baseline models, while our method can produce the intend motions. 
        </p>

  <Grid columns={6} stackable>
  <Grid.Row>
<Grid.Column textAlign="center">
      <img src={seek_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare1d1} />
  <p>
  <strong>CameraCtrl</strong> 
  </p>
    </Grid.Column>

    <Grid.Column textAlign="center">
      <LazyVideo src={excompare1d2} />
  <p>
  <strong>CogVideoX</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare1d3} />
  <p>
  <strong>AC3D</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare1d5} />
  <p>
  <strong>VividCam-AC3D (Ours)</strong> 
  </p>
    </Grid.Column>



    <Grid.Column textAlign="center">
      <LazyVideo src={excompare1d4} />
  <p>
  <strong>VividCam-Cog (Ours)</strong> 
  </p>
    </Grid.Column>

  </Grid.Row>
  </Grid>
<p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> a sunflower in a glass vase. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus</strong> and
  <strong style={{ color: "blue" }}> pushes in</strong> on the vibrant yellow petals.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A sunflower sits in a glass vase on a windowsill, with sunlight streaming in and casting soft shadows on the sill.
</p>



  <Grid columns={6} stackable>
  <Grid.Row>
<Grid.Column textAlign="center">
      <img src={exp_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>


        <Grid.Column textAlign="center">
      <LazyVideo src={excompare2d1} />
  <p>
  <strong>CameraCtrl</strong> 
  </p>
    </Grid.Column>

    <Grid.Column textAlign="center">
      <LazyVideo src={excompare2d2} />
  <p>
  <strong>CogVideoX</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare2d3} />
  <p>
  <strong>AC3D</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare2d5} />
  <p>
  <strong>VividCam-AC3D (Ours)</strong> 
  </p>
    </Grid.Column>



    <Grid.Column textAlign="center">
      <LazyVideo src={excompare2d4} />
  <p>
  <strong>VividCam-Cog (Ours)</strong> 
  </p>
  </Grid.Column>

  </Grid.Row>
  </Grid>
  <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward</strong> with 
  <strong style={{ color: "blue" }}> intermittent explosive tremors, focusing</strong> on a worn-out teddy bear lying on scorched ground.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A car explodes in a fiery blast, sending debris and dust into the air.
</p>



  <Grid columns={6} stackable>
  <Grid.Row>
<Grid.Column textAlign="center">
      <img src={switch_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare3d1} />
  <p>
  <strong>CameraCtrl</strong> 
  </p>
    </Grid.Column>

    <Grid.Column textAlign="center">
      <LazyVideo src={excompare3d2} />
  <p>
  <strong>CogVideoX</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare3d3} />
  <p>
  <strong>AC3D</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare3d5} />
  <p>
  <strong>VividCam-AC3D (Ours)</strong> 
  </p>
    </Grid.Column>



    <Grid.Column textAlign="center">
      <LazyVideo src={excompare3d4} />
  <p>
  <strong>VividCam-Cog (Ours)</strong> 
  </p>
  </Grid.Column>

  </Grid.Row>
  </Grid>
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera
  <strong style={{ color: "blue" }}> pulls out</strong> from a moss-covered rock. Then, the camera
  <strong style={{ color: "blue" }}> zooms in, shifting focus</strong> to a stone pathway.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> The rock rests under the shade of tall trees, while the pathway winds through the forest, its stones carefully placed.
</p>



  <Grid columns={6} stackable>
  <Grid.Row>
<Grid.Column textAlign="center">
      <img src={rot_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>

        <Grid.Column textAlign="center">
      <LazyVideo src={excompare4d1} />
  <p>
  <strong>CameraCtrl</strong> 
  </p>
    </Grid.Column>

    <Grid.Column textAlign="center">
      <LazyVideo src={excompare4d2} />
  <p>
  <strong>CogVideoX</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare4d3} />
  <p>
  <strong>AC3D</strong> 
  </p>
    </Grid.Column>


    <Grid.Column textAlign="center">
      <LazyVideo src={excompare4d5} />
  <p>
  <strong>VividCam-AC3D (Ours)</strong> 
  </p>
    </Grid.Column>



    <Grid.Column textAlign="center">
      <LazyVideo src={excompare4d4} />
  <p>
  <strong>VividCam-Cog (Ours)</strong> 
  </p>
  </Grid.Column>

  </Grid.Row>
  </Grid>
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> orbits</strong> the static candle holder.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A rustic candle holder with a flickering candle rests on a wooden table, accompanied by dried flowers and a brass bell.
</p>



<Header as="h2" textAlign="center" style={subsection_style}>
          Additional Results
        </Header>
        <p>
        We present additional results from two models CogVideoX-LoRA-Wallace_and_Gromit (above row, cartoon style) and Wan2.2-TI2V-5B (below row, additional foundation model).
        </p>

<Grid columns={3} stackable>
      <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttal1} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> orbits </strong>the clay dog in a full circle.
 <br></br>
  <strong style={{ color: "red" }}>Content:</strong> His molded ears tilt with curiosity as the rotating view reveals tiny handcrafted details in his clay texture.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttal2} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching for</strong> a tiny fantasy sprite. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus and pushes in</strong> on the tiny fantasy sprite. 
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> Shimmering clay sparkles trail behind it in stop-motion flickers. 
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttal3} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pulls out </strong>from a quiet clay fireplace. Then, the camera
  <strong style={{ color: "blue" }}> switches focus </strong>to a dog.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> Warm ambient lighting reveals fancy textures in his fur, highlighting sculpt marks.
</p>
    </Grid.Column>
  </Grid.Row>
  </Grid>

<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttal6} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pulls out from </strong>a moss-covered rock. Then, the camera
  <strong style={{ color: "blue" }}> switches focus to </strong>a stone pathway.
 <br></br>
  <strong style={{ color: "red" }}>Content:</strong> The rock rests under the shade of tall trees, while the pathway winds through the forest, its stones carefully placed.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttal5} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> for a steaming loaf of bread. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus</strong> and
  <strong style={{ color: "blue" }}> pushes in</strong> on the golden crust.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A loaf of bread cools on a wooden cutting board, with a knife and a small dish of butter.
</p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttal4} />
      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward</strong> with 
  <strong style={{ color: "blue" }}> intermittent explosive tremors, focusing</strong> on a worn-out car lying on scorched ground. 
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A car explodes in a fiery blast, sending debris and dust into the air.
</p>
    </Grid.Column>
  </Grid.Row>
  </Grid>


<Header as="h2" textAlign="center" style={subsection_style}>
          Rebuttal Videos
        </Header>
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">1. Camera Motions in High Dynamic Scenes</h4>
    </Grid.Column>
  </Grid.Row>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <img src={seek_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq1baseline} />
      <p>
      <strong>Vanilla CogVideoX</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq1ours} />
      <p>
      <strong>VividCam</strong>
      </p>
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> a yellow taxi racing through traffic. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus</strong> and
  <strong style={{ color: "blue" }}> pushes in</strong> as it weaves tightly between lanes.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A busy city avenue with honking cars, flashing lights, and pedestrians moving along sidewalks.
</p>

<br></br>
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">2. Text-Trajectory Alignment</h4>
    </Grid.Column>
  </Grid.Row>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <img src={seek_pose} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq2bird} />
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
We provide both irrelevant camera instruction "The camera rotates 180 degrees in place." and the 3D trajectory. The video follows the trajectory.
</p>


<br></br>
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">3. Figure Presentation</h4>
    </Grid.Column>
  </Grid.Row>
  <Grid.Row>
     <img src={main_figure} style={{ maxWidth: "100%" }} />
  </Grid.Row>
<p>
Overview of our method. 
<strong> Above: Data Synthesis Pipeline.</strong> We first render the initial scene using publicly available assets. Then, we render videos with and without camera motion. These videos are used to train the camera and appearance modules, generating videos with desired camera motions. 
<strong> Bottom-left: Control Mechanism.</strong> Our camera control can be achieved by either camera text instruction or a 3D trajectory as input. 
<strong> Bottom-right: Inference Pipeline.</strong> During inference, the appearance LoRA is dropped.
</p>


<br></br>
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">4. Videos with Semantic Control</h4>
    </Grid.Column>
  </Grid.Row>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <img src={rebuttalq4traj} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Target Camera Pose</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq4vid} />
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
By providing the target 3D trajectory, the video model can produce videos with objects (birds) at correct position.
</p>




<br></br>
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">5. Results without Discarding Appearance LoRA</h4>
    </Grid.Column>
  </Grid.Row>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq5bad0} />
      <p>
      <strong>With Appearance LoRA</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq5good0} />
      <p>
      <strong>Without Appearance LoRA (VividCam)</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
  </Grid.Row>
  </Grid>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq5bad1} />
      <p>
      <strong>With Appearance LoRA</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq5good1} />
      <p>
      <strong>Without Appearance LoRA (VividCam)</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
Without discarding appearance LoRA, the video appears less realistic.
</p>





<br></br>
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">6. Failure Case Examples</h4>
    </Grid.Column>
  </Grid.Row>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq6_1_1} />
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq6_1_2} />
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
<strong>Quality of surroundings: </strong>
The camera instruction are both "push forward". 
The left one is with a plain text prompt "A snowy owl rests on a bare branch, surrounded by a snow-covered forest." 
The right one is with a detailed text prompt "A snowy owl perches on a frost-covered branch, its white feathers blending with the surrounding snow. The forest behind is blanketed in snow, with tall trees standing still and soft light diffused through a pale winter sky."
</p>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq1baseline} />
      <p>
      <strong>Vanilla CogVideoX</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq1ours} />
      <p>
      <strong>VividCam</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
<strong>Quality in dynamic scenes: </strong>
VividCam inherits the ghost artifacts of base model CogVideoX when in a highly dynamic scenes. 
</p>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq6_3} />
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
    <Grid.Column textAlign="center">
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
<strong>Quality with long, complex camera actions: </strong>
The target camera motion is: “The camera pulls out from a woven basket, then zooms in to focus on a sunflower in a nearby patch of sunflowers.” The video successfully demonstrates the first part of the motion, pulling out from the basket, but completes only part of the second action, zooming in to focus on a sunflower.
</p>




<br></br>
  <Grid.Row>
    <Grid.Column width={16}>
      <h4 align="center">7. Comparison with DualCamCtrl</h4>
    </Grid.Column>
  </Grid.Row>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <img src={gray_depth_1} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Gray depth image required by DualCamCtrl</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq7dual_switch} />
      <p>
      <strong>DualCamCtrl</strong> <strong style={{ color: "green" }}>SUCCESS</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq7ours_switch} />
      <p>
      <strong>VividCam</strong> <strong style={{ color: "green" }}>SUCCESS</strong>
      </p>
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera
  <strong style={{ color: "blue" }}> pulls out</strong> from a moss-covered rock. Then, the camera
  <strong style={{ color: "blue" }}> zooms in, shifting focus</strong> to a stone pathway.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> The rock rests under the shade of tall trees, while the pathway winds through the forest, its stones carefully placed.
</p>
<Grid columns={3} stackable>
        <Grid.Row>
    <Grid.Column textAlign="center">
      <img src={gray_depth_2} style={{ maxWidth: "100%" }} />
      <p>
      <strong>Gray depth image required by DualCamCtrl</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq7dual_seek} />
      <p>
      <strong>DualCamCtrl</strong> <strong style={{ color: "red" }}>FAIL</strong>
      </p>
    </Grid.Column>
    <Grid.Column textAlign="center">
      <LazyVideo src={rebuttalq7ours_seek} />
      <p>
      <strong>VividCam</strong> <strong style={{ color: "green" }}>SUCCESS</strong>
      </p>
    </Grid.Column>
  </Grid.Row>
  </Grid>
<p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> for a static steaming loaf of bread. Upon finding it, the camera
  <strong style={{ color: "blue" }}> locks focus</strong> and
  <strong style={{ color: "blue" }}> pushes in</strong> on the golden crust.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A loaf of bread cools on a wooden cutting board, with a knife and a small dish of butter.
</p>




<br></br>
      </Container>
    </div>
  </ResponsiveContainer>
);



export default HomepageLayout;
